export default {
  comment: {
    include_comment_user: true,
  },
  conversation: {
    include_conversation_comments: true,
    include_conversation_subscribers: true,
  },
  image: {
    include_image_sizes: true,
  },
  subscriber: {
    include_subscriber_user: true,
  },
  taskList: {
    include_task_list_owner: true,
    include_task_list_progress_status: true,
  },
  templateGroup: {
    include_template_group_task_lists: true,
  },
  user: {
    include_user_image: true,
  },
}
